import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Button,
    Autocomplete,
    TextField,
    Box,
    IconButton,
    FormControl,
    Stack,
} from "@mui/material";
import { filterOptions } from "../../../global/constants/globalContants.ts";
import DeleteIcon from "@mui/icons-material/Delete";
import { ApideleteAirTasker, ApiGetShopperList } from "../../../apiService/Core/Apicall.tsx";
import { toast } from "react-toastify";
const AirTaskerList: React.FC = () => {
    const navigate = useNavigate();
    // const addOrUpdateairtasker = (airtasker: any) {
    //     if (airtasker.userId) {
    //         navigate('')
    //     }
    // }
    const [shoppersList, setShoppersList] = useState<any>([])
    const [selectedFilter, setSelectedFilter] = useState<any>(null)
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const handleGetApiCall = async (status?: string) => {
        try {
            const filterStatus = status || selectedFilter?.value || "active"
            const data = `?offset=0&limit=1000&isAirTasker=true&status=${filterStatus}`
            const res = await ApiGetShopperList(data)
            setShoppersList(res.data)
        } catch (error) {
            console.error("Error during API call:", error)
        }
    }

    const handleFilterChange = async (event: any, newValue: any) => {
        setSelectedFilter(newValue)
        setPage(0)
        if (newValue) {
            await handleGetApiCall(newValue.value)
        }
    }
    const deleteAirTasker = async (user: any) => {
        const data = {
            userId: user.userId,
        };
        try {
            const response: any = await ApideleteAirTasker(data); 
            toast.success("AirTasker deleted successfully!");
            handleGetApiCall();
        } catch (error) {
            console.error("Error during API call:", error);
            toast.error("Failed to delete AirTasker");
        }
    };
    useEffect(() => {
        const fetchData = async () => {
            const defaultFilter = filterOptions[0]
            setSelectedFilter(defaultFilter)
            await handleGetApiCall(defaultFilter.value)
        }
        fetchData()
        return () => { }
    }, [])
    const currentShoppers = shoppersList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    return (
        <Box className="manage-admin-container">
            <Box className="manage-button">
                <Stack className="ml-2" direction="row" spacing={2}>
                    <Box style={{ width: "100%" }}>
                        <Box sx={{ mb: 3, ml: 2, display: "flex", gap: 2, alignItems: "center", width: "fit-content" }}>
                            <Autocomplete
                                options={filterOptions}
                                value={selectedFilter}
                                getOptionLabel={(option) => option.label}
                                onChange={handleFilterChange}
                                renderInput={(params) => <TextField {...params} label="Filter by Status" />}
                                sx={{ minWidth: 200 }}
                            />
                        </Box>
                    </Box>
                </Stack>
                <h1 className="common-manage-h1" style={{ marginRight: 200 }}>Air Tasker List</h1>
                <Box className="add-button common-manage-button">
                    <Button
                        variant="contained"
                        onClick={() => { navigate('/admin/shopper/add') }}
                        className="table-row-background "
                    >
                        Add New AirTasker
                    </Button>
                </Box>
            </Box>
            <Table>
                <TableHead>
                    <TableRow className="table-row-background">
                        {[
                            "First Name",
                            "Last Name",
                            "User Name",
                            "Email ID",
                            "",
                            "",
                        ].map((item) => (
                            <TableCell style={{ color: "#fff" }}>{item}</TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {currentShoppers?.map((user) => (
                        <TableRow key={'user.userId'}>
                            <TableCell>{user.firstName}</TableCell>
                            <TableCell>{user.lastName}</TableCell>
                            <TableCell>{user.userName}</TableCell>
                            <TableCell>{user.emailId}</TableCell>
                            <TableCell>
                                <Button
                                    variant="contained"
                                    onClick={() => {
                                        navigate(`/admin/shopper/update/${user.userId}`, {
                                            state: { shopperDetails: user },
                                        })
                                    }}
                                    className="table-row-background"
                                >
                                    Edit
                                </Button>
                            </TableCell>
                            <TableCell>
                                <Button
                                    variant="contained"
                                    className="delete-transparent"
                                    onClick={() => {
                                        const isConfirmed = window.confirm(
                                            "Are you sure you want to delete the client?"
                                        );
                                        if (isConfirmed) {
                                            deleteAirTasker(user);
                                        }
                                    }}
                                >
                                    <DeleteIcon className="delete-icon" />
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Box>
    )
}
export default AirTaskerList;
